<!-- Empty layout -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- Modern -->
<modern-layout *ngIf="layout === 'modern'"></modern-layout>

<!-- Classy -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>